module.exports = __webpack_public_path__ + "src/assets/img/smoke_five.8a7a3cd1.svg";